import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { compose, hoistStatics, lifecycle, withState, defaultProps, withHandlers, withProps } from 'recompose';
import ReactSVG from 'react-svg';
import { toast } from 'react-toastify';
import { matchPath, withRouter } from 'react-router-dom';

import Documents from './Documents';
import Select from '../../../../components/form/niceSelect';
import DocumentService from '../../../../services/document.service';
import ModuleService from '../../../../services/module.service';
import gh from '../../../../helpers/grid.helper';
import columnTypes from '../../../../components/list/grid/columnTypes';
import { uploadActions } from '../../../../reducers/upload';
import ch from '../../../../helpers/currentUser.helper';

const postSelectData = ({
  currentItem,
  setUpdated,
  t,
}) =>
  async ({ target }) => {
    const newVal = target.value;
    const resp = await DocumentService.updateAttribute(currentItem.id, target.name, newVal);
    if (resp.model) {
      await setUpdated({ id: currentItem.id });
      toast.success(t('Access changed'));
    }
  };

const toggleModal = props => (e, activeStatus) => {
  e.preventDefault();
  props.setActiveModal(activeStatus);
};

const onEditSelect = props => (e, item) => {
  e.preventDefault();
  const { setActiveItem } = props;
  setActiveItem(item);
  toggleModal(props)(e, 1);
};

const callback = props => async (formData) => {
  const { setUpdated, t } = props;
  const { access_type, models } = formData;
  let newModel = [];
  if (access_type !== DocumentService.ACCESS_TYPE_PUBLIC) {
    newModel = models[access_type] || [];
  }
  const resp = await DocumentService.update({ ...formData, models: newModel });
  if (resp.model) {
    await setUpdated({ id: formData.id });
    toast.success(t('Access changed'));
  }
};

const onClickSave = props => async (e) => {
  e.preventDefault();
  const {
    setUpdated,
    upload_name,
    mulTempFiles,
    isSubmitting,
    setIsSubmitting,
    removeMulTempFiles,
  } = props;
  if (!isSubmitting) {
    setIsSubmitting(true);
    const files = mulTempFiles[upload_name] || [];
    const filesIds = files.map(file => ({ file_id: file.id,
      access_type: file.access_type || DocumentService.ACCESS_TYPE_PUBLIC,
      models: file.models,
    }));
    const { data } = await DocumentService.saveMany({ documents: filesIds });
    if (data.files) {
      removeMulTempFiles(upload_name);
      setUpdated({ page: 0 });
    }
    setIsSubmitting(false);
  }
};

const onDelete = async (e, { item, service, updateData, destroyItem }) => {
  e.preventDefault();
  destroyItem(item.id);
  // showDelete(e);
  // await service.destroy(item.id);
  // await updateData();
};

const getColumns = props => [
  {
    name: 'original',
    sort: false,
    cssClass: 'doccol_1',
    value: ({ item }) => (
      <span className="tb-td_docs">
        <a
          href="#"
          className={`three-dots doctags ${gh.getFileType(item.original)}-tag`}
          onClick={e => e.preventDefault()}
        >{item.type}
        </a>
        <span className="three-dots">{item.original}</span>
      </span>
    ),
  },
  {
    name: 'created_at',
    title: props.t('Date added'),
    cssClass: 'doccol_2',
  },
  {
    name: 'id',
    title: '',
    value: col => (<span onClick={() => col.destroyItem(col.item.id)}>x</span>),
  },
];

const toggleModalPreview = props => (e, activateStatus, id) => {
  if (e)e.preventDefault();
  const { history, setActiveItem } = props;
  if (activateStatus) {
    history.push(`/my-docs/${id}`);
  } else {
    setActiveItem(null);
    history.push('/my-docs');
  }
};


const callbackToSetDoc = props => (e, doc) => {
  props.setActiveItem(doc);
  if (!e.target.closest('.tb-lst')) toggleModalPreview(props)(e, true, doc.id);
};

// confirm
const showDelete = props => (e) => {
  e.preventDefault();
  props.setShowConfirm(true);
};

const hideConfirm = ({ setShowConfirm }) => () => {
  setShowConfirm(false);
};

const onRemoveCallback = props => async () => {
  const { setUpdated, setChecked, setShowConfirm, t } = props;
  const formData = ch.prepareData(props.checked);
  if (formData.length) {
    setShowConfirm(false);
    const deleteSuccess = await DocumentService.destroyAllByIds(formData);
    setUpdated({ removed: deleteSuccess });
    setChecked({});
    if (deleteSuccess.length) {
      toast.success(t('Documents removed'));
    } else { toast.error(t('Something went wrong')); }
  }
};

const callbackMass = props => async (formData) => {
  const { setUpdated, t, checked, setChecked } = props;
  const { access_type, models } = formData;
  let newModel = [];
  if (access_type !== DocumentService.ACCESS_TYPE_PUBLIC) {
    newModel = models[access_type] || [];
  }
  const ids = ch.prepareData(checked);
  setChecked({});
  if (ids.length) {
    toast.success(t('Your changes has been sent! Please wait!'));
    const resp = await DocumentService.changeStatus(ids, access_type, newModel);
    if (resp.status) {
      setUpdated({ id: formData });
      toast.success(t('Access changed'));
    } else {
      toast.error(t('Something went wrong, please contact support'));
    }
  }
};

const callbackToSetSearch = props => async (value) => {
  // console.log('search', value);
  props.setOriginal(value);
  // const { criteria } = props;
  // await goToPage({ ...props, criteria: { ...criteria, original: value } })(0);
};

const toggleModalMass = props => (e, activeStatus) => {
  e.preventDefault();
  props.setActiveModalMass(activeStatus);
};

const mapStateToProps = state => ({
  mulTempFiles: state.upload.mulTempFiles,
  user: state.user.user,
  modulesSettings: state.modules.modulesSettings,
});

const mapDispatchToProps = {
  removeMulTempFiles: uploadActions.removeMulTempFiles,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', true),
  withState('updated', 'setUpdated', {}),
  withState('checked', 'setChecked', {}),
  withState('color', 'setColor', ''),
  withState('original', 'setOriginal', ''),
  withState('activeModal', 'setActiveModal', false),
  withState('activeModalMass', 'setActiveModalMass', false),
  withState('activeItem', 'setActiveItem', null),
  withState('isSubmitting', 'setIsSubmitting', false),
  withState('showConfirm', 'setShowConfirm', false),
  withState('isErrorGrid', 'setIsErrorGrid', { status: true, type: gh.ERROR_GRID_INITIAL }),
  translate('portal'),
  withProps(props => ({
    backgroundColor: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].color ?
      props.modulesSettings[ModuleService.TYPE_DOCUMENTS].color : props.modulesSettings[ModuleService.TYPE_DOCUMENTS].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].cover,
    enableCoverColor: props.modulesSettings[ModuleService.TYPE_DOCUMENTS].enable_cover_color,
    getDatesNames: DocumentService.getDatesNames(props),
    initCriteria: {
      order: 'desc',
      created_at: '',
      original: '',
      access_type: '',
      limit: 10,
      sortBy: 'created_at',
      created_by: props.user.id,
      is_folder: 0,
    },
  })),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading, setColor, moduleData, setActiveItem } = this.props;
      // setColor((moduleData.subscriberModules && moduleData.subscriberModules.color) ?
      //   moduleData.subscriberModules.color : moduleData.module.default_color);
      const match = matchPath(this.props.history.location.pathname, {
        path: '/my-docs/:id',
        exact: true,
        strict: false,
      });

      if (match && match.params && match.params.id !== undefined) {
        setActiveItem({ id: parseInt(match.params.id, 10) });
      }
      setIsLoading(false);
    },
  }),
  defaultProps({
    getColumns,
    upload_name: 'documents',
  }),
  withHandlers({
    callback,
    showDelete,
    hideConfirm,
    toggleModal,
    onClickSave,
    callbackMass,
    toggleModalMass,
    callbackToSetSearch,
    callbackToSetDoc,
    onRemoveCallback,
    toggleModalPreview,
    callbackError: gh.callbackError,
  }),
);

export default withRouter(hoistStatics(enhance)(Documents));



// WEBPACK FOOTER //
// ./src/views/modules/documents/mydocs/index.js